<template>
  <div class="page px-5">
    <page-layout>
      <h3
        v-if="this.$route.path === '/apiResources/new'"
        slot="header"
        class="my-4"
      >
        New Api Resource
      </h3>
      <h3
        v-else
        slot="header"
        class="my-4"
      >
        Edit Api Resource
      </h3>
      <api-resource-detail-form />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import ApiResourceDetailForm from "@/components/apiResources/ApiResourceDetailForm.vue";
export default {
  components: {
    PageLayout,
    ApiResourceDetailForm
  }
};
</script>
